@if (items?.length || htmlContents?.length) {
  @if (ticker) {
    <div id="scrollingText" class="inview">
      <div class="scrollWrapper marquee" #marquee>
        <div class="scrollableArea play" [class.paused]="!isPlay">
          <div>
            @for (item of items; track item) {
              <div class="ticker__item">
                <div [innerHtml]="(templates$|async)[previewTemplateVar]| replaceTokensArray: {keys: item, previewVar: previewTemplateVar} | safe: 'html'"></div>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  }
  @if (!ticker) {
    @if (!thumbsSwiperConfig) {
      <ng-content select=".before-swiper-slides"></ng-content>
      @if ((templates$|async)) {
        <swiper
          [config]="swiperConfig"
          #swiper>
          @for (item of items; track item) {
            <ng-template swiperSlide>
              @if (previewTemplateVar) {
                <div [innerHtml]="(templates$|async)[previewTemplateVar]| replaceTokensArray: {keys: item, previewVar: previewTemplateVar} | safe: 'html'"></div>
              }
              @if (!previewTemplateVar) {
                <div [innerHTML]="item | safe: 'html'" ></div>
              }
            </ng-template>
          }
        </swiper>
      }
      <ng-content select=".after"></ng-content>
    }
    @if (thumbsSwiperConfig) {
      <ng-content select=".before"></ng-content>
      @if (htmlContents?.length || items?.length) {
        <swiper
          class="mySwiper2"
          [config]="swiperConfig"
          [thumbs]="{ swiper: thumbsSwiper }"
          #swiper>
          @if (htmlContents?.length) {
            @for (html of htmlContents; track html) {
              <ng-template swiperSlide>
                <div [innerHTML]="html | safe: 'html'" ></div>
              </ng-template>
            }
          }
          @if (items?.length) {
            @for (item of items; track item) {
              <ng-template swiperSlide>
                @if ((templates$ | async)?.[previewTemplateVar]) {
                  <div [innerHtml]=" (templates$ | async)?.[previewTemplateVar] | replaceTokensArray: {keys: item, previewVar: previewTemplateVar} | safe: 'html'"></div>
                }
              </ng-template>
            }
          }
        </swiper>
      }
      @if (thumbsSwiperConfig['htmlContents']?.length || thumbsSwiperConfig['items']?.length) {
        <swiper
          class="mySwiper"
          [config]="thumbsSwiperConfig['swiperConfig']"
          (swiper)="thumbsSwiper = $event"
          #swiper>
          @if (thumbsSwiperConfig['htmlContents']?.length) {
            @for (html of thumbsSwiperConfig['htmlContents']; track html) {
              <ng-template swiperSlide>
                <div [innerHTML]="html | safe: 'html'" ></div>
              </ng-template>
            }
          }
          @if (thumbsSwiperConfig['items']?.length) {
            @for (item of thumbsSwiperConfig['items']; track item) {
              <ng-template swiperSlide>
                <div [innerHtml]="(templates$|async)[thumbsSwiperConfig['previewTemplateVar']]| replaceTokensArray: {keys: item, previewVar: thumbsSwiperConfig['previewTemplateVar']} | safe: 'html'"></div>
              </ng-template>
            }
          }
        </swiper>
      }
      <ng-content select=".after"></ng-content>
    }
  }
  @if (showPlayButton && isPlay) {
    <button class="btn-swiper-pause mx-3"
      [attr.aria-pressed]="isPlay"
      style="position: absolute; right: 15px; bottom: 0; z-index: 1000;"
      (click)="stopPlay()"
      attr.aria-label="{{'Disable carousel auto play' | translate}}">
      <i class="material-icons align-middle d-none">pause_circle_outline</i>
      <i class="fa fa-pause"></i>
    </button>
  }
  @if (showPlayButton && !isPlay) {
    <button class="btn-swiper-play mx-3"
      [attr.aria-pressed]="isPlay"
      style="position: absolute; right: 15px; bottom: 0; z-index: 1000;"
      (click)="startPlay()"
      attr.aria-label="{{'Enable carousel auto play' | translate}}">
      <i class="material-icons align-middle d-none">play_circle_outline</i>
      <i class="fa fa-play"></i>
    </button>
  }
}
@if (htmlContents && htmlContents.length == 0 && noImage) {
  <div class="no-image" [innerHTML]="noImage | safe: 'html'" ></div>
}
